<template>
  <div class="theme_lighten theme_background map-layers">
    <div class="search-box px-5 pb-3 pt-3 bodyTexts">
      <v-text-field
        v-model="search"
        class="searchField"
        :placeholder="$t('common.concepts.searchPlaceholder')"
        prepend-inner-icon="mdi-magnify"
        bg-color="rgb(var(--v-theme-surface))"
        hide-details
        density="compact"
        variant="solo"></v-text-field>
    </div>

    <div class="layers-container">
      <LayerGroup v-for="LayerTOC in KaronteLayersTOC" :key="LayerTOC.name" :layers="LayerTOC.layers" :group="LayerTOC.name">
        <p class="grey_colored">
          {{ $t(`views.layers.${LayerTOC.name}`) }}
        </p>
      </LayerGroup>
    </div>

    <div class="theme_surface_background">
      <v-btn icon="mdi-plus" color="primary" class="absolute d-none"></v-btn>
    </div>
  </div>
</template>

<script lang="ts" setup>
// Framework import
import { computed, ref } from 'vue'

// Karonte import
import { storeToRefs } from 'pinia'

import useLayers from '@tsyl/karonte/lib/composables/useLayers'
import type { Layer } from '@tsyl/karonte/lib/types/layers'
import karonteI18n from '@tsyl/karonte/lib/utils/i18n'

// Components import
import { non_authenticated } from '@/constants/layers'
import AuthStore from '@/stores/auth'
import type { OrganizationLayersTOCLoaded } from '@/types/OrganizationLayers.ts'
import { filterTOC } from '@/utils/mapToc.ts'

import LayerGroup from './MapLayers/LayerGroup.vue'

// Auth import

const authStore = AuthStore()
const { org } = storeToRefs(authStore)

const karonteI18nObject = karonteI18n(`sa`, {})

const { translateLangsKeyObject } = karonteI18nObject

const search = ref('')

const { allLayers } = useLayers()

const KaronteLayersTOC = computed<OrganizationLayersTOCLoaded[]>(() => {
  const filteredLayers: Layer[] = (allLayers.value ?? []).filter((l) => {
    return translateLangsKeyObject(l.rawData.title)?.toUpperCase().includes(search.value.toUpperCase())
  })
  return filterTOC(org?.value?.toc ?? non_authenticated.toc, filteredLayers)
})
</script>

<style scoped lang="scss">
:deep(.v-field__input) {
  padding-top: 8px !important;
  color: rgb(var(--v-theme-surface-variant)) !important;
}

:deep(.v-field__prepend-inner) {
  color: rgb(var(--v-theme-surface-variant)) !important;
}

.border5 {
  border-radius: 5px;
}

.absolute {
  // position: absolute;
  bottom: 35px;
  left: 320px;
}

.map-layers {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.layers-container {
  overflow-y: auto;
  background-color: rgb(var(--v-theme-surface));
}

.search-box {
  background-color: rgb(var(--v-theme-surface-light));
}
</style>
